import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { Component, createRef, render } from 'preact';
import { AuctionAPI } from '../api/AuctionClient';
import { InfomationModal } from './auction/InfomationModal';
import { MailToOrganizerModal } from './auction/MailToOrganizerModal';
class AuctionInfomationComponent extends Component {
    constructor(props) {
        super(props);
        this.infomationModalRef = createRef();
        this.mailToModalRef = createRef();
    }
    componentDidMount() {
        document.querySelector('.AuctionPanelTrigger')?.addEventListener('click', () => {
            this.handleOpenInfoModal();
        });
    }
    render() {
        return (_jsxs("section", Object.assign({ class: "FirstPayAuctionPanel" }, { children: [_jsx(InfomationModal, { auction: this.props.auction, questionModalHook: () => { this.handleOpenMailToModal(); }, ref: this.infomationModalRef, env: '' }, void 0),
                _jsx(MailToOrganizerModal, { auction: this.props.auction, hookClose: () => { this.handleOpenInfoModal(); }, ref: this.mailToModalRef, env: '' }, void 0)] }), void 0));
    }
    handleOpenInfoModal() {
        this.infomationModalRef.current?.handleOpen();
    }
    handleOpenMailToModal() {
        this.infomationModalRef.current?.handleClose();
        this.mailToModalRef.current?.handleOpen();
    }
}
document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('#AuctionInfomationComponent');
    const auctionId = root?.getAttribute('data-auction-uid');
    if (auctionId) {
        AuctionAPI.get(auctionId, '').then(response => {
            const root = document.body.appendChild(document.createElement('div'));
            render(_jsx(AuctionInfomationComponent, { auction: response.data }, void 0), root);
        });
    }
});
